import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const educationDetails = [
    {
      yearRange: "2020 - 2021",
      title: "Masters Degree (MSc) in Computing",
      place: "University of Dundee",
    },
    {
      yearRange: "2015 – 2019",
      title: "Bachelor of Science (BSc Hons) in Computing",
      place: "University of Dundee & Open University",
    },
    {
      yearRange: "2013 - 2015",
      title: "HND in Software Engineering",
      place: "Dundee & Angus College",
    },
  ];

  const experienceDetails = [
    {
      yearRange: "2024 - Present",
      title: "Software Engineer (React & API)",
      place: "Lloyds Banking Group",
    },
    {
      yearRange: "2021 - 2024",
      title: "Full Stack Developer",
      place: "Tera Web Services (Contract/Freelance)",
    },
    {
      yearRange: "2018 - 2020",
      title: "Software Developer",
      place: "Tiger Moon Interactive",
    },
    {
      yearRange: "2017 - 2018",
      title: "Junior Software Engineer",
      place: "BCM Microelectronics",
    },
  ];

  const skills = [
  {
    category: "Frontend Engineering",
    items: [
      "React",
      "JavaScript / TypeScript",
      "HTML / CSS",
      "Modern CSS & Responsive Design",
      "Responsive & Accessible UI",
    ],
  },
  {
    category: "Backend Engineering",
    items: [
      "Python",
      "Django",
      "Node.js",
      ".NET Core / C#",
    ],
  },
  {
    category: "APIs & Data",
    items: [
      "REST APIs",
      "SQL",
      "Relational Database Design",
    ],
  },
  {
    category: "Cloud & Delivery",
    items: [
      "AWS",
      "Google Cloud Platform",
      "Docker",
      "CI/CD Pipelines",
      "Git",
    ],
  },
  {
    category: "Additional Languages",
    items: [
      "Java",
      "C++",
      "Swift / SwiftUI",
    ],
  },
];

  return (
    <section id="resume" className="section">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Resume</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A summary of My Resume
        </h2>
        {/* Heading end*/}
        <div className="row g-5 mt-5">
          {/* My Education */}
          <div className="col-lg-6 wow fadeInUp">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Education</h2>
            <div className="border-start border-2 border-primary ps-3">
              {educationDetails.length > 0 &&
                educationDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
          {/* My Experience */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.2s">
            <h2 className="text-7 fw-600 mb-4 pb-2">My Experience</h2>
            <div className="border-start border-2 border-primary ps-3">
              {experienceDetails.length > 0 &&
                experienceDetails.map((value, index) => (
                  <div key={index}>
                    <h3 className="text-5">{value.title}</h3>
                    <p className="mb-2">
                      {value.place} / {value.yearRange}
                    </p>
                    <p className="text-muted">{value.desc}</p>
                    <hr className="my-4" />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* My Skills */}
        <h2 className="text-7 fw-600 mb-4 pb-2 mt-5 wow fadeInUp">
          My Engineering Skills
        </h2>

        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skillGroup, index) => (
              <div className="col-md-6 wow fadeInUp mb-4" key={index}>
                <div className="skills-card p-4 h-100 shadow-sm rounded bg-white">
                  <h3 className="skills-card-header text-5 fw-600 mb-3">
                    <span className="skills-card-header-text bg-primary px-2">{skillGroup.category}</span>
                  </h3>

                  <ul className="list-unstyled mb-0">
                    {skillGroup.items.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className="fw-500 text-start mb-2"
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
        </div>
        <p className="text-center mt-5 wow fadeInUp">
          <a
            className="btn btn-outline-dark shadow-none rounded-0"
            href={resumeFile}
            download
          >
            Download CV
          </a>
        </p>
      </div>
    </section>
  );
};

export default Resume;
